// RingKeeper marketing site — minimal vanilla JS.
// The site has no form: the demo phone number is the only CTA, and the AI
// agent on the other end of it both demos itself and books real meetings.
// So the only JS responsibility left is keyboard-focus for in-page anchors.
// If this file ever grows beyond a single feature, reconsider — we're
// aggressively keeping the page small and dependency-free.

(function () {
  'use strict';

  // CSS already sets `scroll-behavior: smooth` (and disables it under
  // prefers-reduced-motion). This handler exists to also move keyboard /
  // screen-reader focus to the target after an anchor click.
  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      var hash = link.getAttribute('href');
      if (!hash || hash.length < 2) { return; }

      var target = document.querySelector(hash);
      if (!target) { return; }

      event.preventDefault();
      target.scrollIntoView({ behavior: prefersReduced ? 'auto' : 'smooth', block: 'start' });

      // tabindex=-1 + focus() so non-focusable section elements still take focus.
      var prevTabIndex = target.getAttribute('tabindex');
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
      if (prevTabIndex === null) {
        target.removeAttribute('tabindex');
      }

      // Update URL without polluting history.
      if (history.replaceState) {
        history.replaceState(null, '', hash);
      }
    });
  });
})();
